import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section className="w-full bg-shell py-20 md:py-28" aria-labelledby="beneficios" data-id="element-19" data-mp="3iq80k0dkssaq">
      <div className="mx-auto max-w-5xl px-6 lg:px-8" data-id="element-20" data-mp="3iodprew0qgkd">
        <SectionHeading eyebrow="Siete días" title={<span id="beneficios" data-id="element-22" data-mp="3nmyf2j9qffu1">En 7 días empezarás a…</span>} data-id="element-21" data-mp="3no9k0mewytmq" />

        <ul className="mt-14 grid gap-x-10 gap-y-1 sm:grid-cols-2" data-id="element-23" data-mp="38r937dy9gj31">
          {benefits.map((benefit, i) => <Reveal key={benefit} delay={i * 0.06} data-id="element-24" data-mp="3drwp5l7mu9qe" data-mpi={i}>
              <li className="flex items-start gap-4 border-b border-sand py-5" data-id="element-25" data-mp="2zrlxwh2eut4p">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-ivory font-sans text-[0.65rem] text-gold" data-id="element-26" data-mp="2ztox9rpgdym3">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="font-sans text-[1rem] font-light leading-relaxed text-ink" data-id="element-27" data-mp="12ysh9z2ie946">
                  {benefit}
                </span>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}